import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Renders a DOM element to a multi-page Letter PDF (white theme via the temporary `pdf-light` class) and downloads it.
export async function downloadElementPdf(el, filename) {
  el.classList.add("pdf-light");
  try {
    const canvas = await html2canvas(el, { backgroundColor: "#ffffff", scale: 2, useCORS: true, logging: false, windowWidth: 900 });
    const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "letter" });
    const pageW = pdf.internal.pageSize.getWidth(), pageH = pdf.internal.pageSize.getHeight(), margin = 32;
    const imgW = pageW - margin * 2;
    const pxPerPt = canvas.width / imgW;
    const pageHeightPx = Math.floor((pageH - margin * 2) * pxPerPt);
    let y = 0, first = true;
    while (y < canvas.height) {
      const sliceH = Math.min(pageHeightPx, canvas.height - y);
      const slice = document.createElement("canvas");
      slice.width = canvas.width; slice.height = sliceH;
      slice.getContext("2d").drawImage(canvas, 0, y, canvas.width, sliceH, 0, 0, canvas.width, sliceH);
      if (!first) pdf.addPage();
      pdf.addImage(slice.toDataURL("image/jpeg", 0.92), "JPEG", margin, margin, imgW, sliceH / pxPerPt);
      y += sliceH; first = false;
    }
    pdf.save(filename);
  } finally {
    el.classList.remove("pdf-light");
  }
}
